// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const FormatUnderline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero">
      <path d="M17 4v8.59c0 1.506-.508 2.657-1.44 3.454-.848.797-2.12 1.24-3.56 1.24-1.525 0-2.712-.443-3.644-1.24C7.424 15.247 7 14.096 7 12.59V4h2.542v8.59c0 .886.255 1.506.678 2.037.424.443 1.017.708 1.78.708.763 0 1.356-.265 1.864-.708.424-.443.678-1.151.678-2.037V4H17zM6 19h12v2H6z" />
    </g>
  </svg>
);

export default FormatUnderline;
